import PrivacyPolicyPage from 'components/pages/privacy-policy/PrivacyPolicyPage';
import Seo from 'components/Seo';
import { graphql } from 'gatsby';
import * as React from 'react';

const Index = () => (
	<div>
		<Seo
			title='Polityka prywatności | FINTEQ'
			keywords='Polityka prywatności, zasady korzystania'
			description='Polityka prywatności i zasady korzystania.'
			lang='pl-PL'
			locale='pl_PL'
		/>

		<PrivacyPolicyPage />
	</div>
);

export default Index;

export const query = graphql`
    query ($language: String!) {
        locales: allLocale(filter: {language: {eq: $language}}) {
            edges {
                node {
                    ns
                    data
                    language
                }
            }
        }
    }
`;
